import { t } from '@/lib/i18n';
import type { BmcCanvasBlockKey, RorosCanvasBlockKey, VpcCanvasBlockKey } from '@/types/roros/canvases';

// Scanner-visible registration for dynamic t(block.label) calls in the canvas UI.
// Keep the labels themselves as plain keys so canvas rendering remains runtime-locale reactive.
export function registerCanvasBlockLabelTranslationKeysForScanner(): string[] {
  return [
    t('Key Partners'),
    t('Key Activities'),
    t('Key Resources'),
    t('Value Propositions'),
    t('Customer Relationships'),
    t('Channels'),
    t('Customer Segments'),
    t('Cost Structure'),
    t('Revenue Streams'),
    t('Products & Services'),
    t('Gain Creators'),
    t('Pain Relievers'),
    t('Customer Jobs'),
    t('Customer Pains'),
    t('Customer Gains'),
  ];
}

export const BMC_BLOCKS: Array<{ key: BmcCanvasBlockKey; label: string; className?: string }> = [
  { key: 'key_partners', label: 'Key Partners', className: 'lg:row-span-2' },
  { key: 'key_activities', label: 'Key Activities' },
  { key: 'value_propositions', label: 'Value Propositions', className: 'lg:row-span-2' },
  { key: 'customer_relationships', label: 'Customer Relationships' },
  { key: 'customer_segments', label: 'Customer Segments', className: 'lg:row-span-2' },
  { key: 'key_resources', label: 'Key Resources' },
  { key: 'channels', label: 'Channels' },
];

export const BMC_BOTTOM_BLOCKS: Array<{ key: BmcCanvasBlockKey; label: string }> = [
  { key: 'cost_structure', label: 'Cost Structure' },
  { key: 'revenue_streams', label: 'Revenue Streams' },
];

export const VPC_VALUE_MAP_BLOCKS: Array<{ key: VpcCanvasBlockKey; label: string }> = [
  { key: 'products_services', label: 'Products & Services' },
  { key: 'gain_creators', label: 'Gain Creators' },
  { key: 'pain_relievers', label: 'Pain Relievers' },
];

export const VPC_CUSTOMER_PROFILE_BLOCKS: Array<{ key: VpcCanvasBlockKey; label: string }> = [
  { key: 'customer_jobs', label: 'Customer Jobs' },
  { key: 'customer_pains', label: 'Customer Pains' },
  { key: 'customer_gains', label: 'Customer Gains' },
];

export const AI_GAP_BLOCK_KEYS: readonly RorosCanvasBlockKey[] = [
  'key_partners',
  'key_activities',
  'key_resources',
  'customer_relationships',
  'channels',
  'cost_structure',
  'revenue_streams',
  'gain_creators',
  'pain_relievers',
  'customer_gains',
];

export function createEmptyBlocks(keys: readonly RorosCanvasBlockKey[]) {
  return Object.fromEntries(keys.map((key) => [key, { items: [] }]));
}
